import { IDataGridColumnConfiguration, constants } from '@trackman/baseball-shared-components';
import { EditRowColumnName } from 'enums/EditRowColumnName';
import { IDataGridValidator } from '@trackman/baseball-shared-components/build/models/DataGrid/IDataGridValidator';
import { PlayRow } from 'models/PlayEditRow/PlayRow';
import { IDataGridError } from '@trackman/baseball-shared-components/build/models/DataGrid/IDataGridError';
import { IEditRowPlayer } from 'interfaces/sessionVerification/plays/IEditRowPlayer';
import { isPlayerCellEmpty } from './ValidationHelpers';

export const playerValidator: IDataGridValidator = {
  validate: (rows: PlayRow[], columns: IDataGridColumnConfiguration[]) => {
    const pitcherColumn = columns.find((c) => c.columnName === EditRowColumnName.Pitcher);
    const batterColumn = columns.find((c) => c.columnName === EditRowColumnName.Batter);
    const catcherColumn = columns.find((c) => c.columnName === EditRowColumnName.Catcher);
    if (!pitcherColumn || !batterColumn || !catcherColumn) {
      return rows.map(() => []);
    }
    return rows.map((r) => validateRow(r, pitcherColumn, batterColumn, catcherColumn));
  },
};

const validateRow = (
  row: PlayRow,
  pitcherColumn: IDataGridColumnConfiguration,
  batterColumn: IDataGridColumnConfiguration,
  catcherColumn: IDataGridColumnConfiguration
) => {
  const errors: IDataGridError[] = [];
  if (row.isWarmup || row.isDeleted) {
    return [];
  }
  const pitcher = row[pitcherColumn.dataKey] as IEditRowPlayer;
  const batter = row[batterColumn.dataKey] as IEditRowPlayer;
  const catcher = row[catcherColumn.dataKey] as IEditRowPlayer;
  if (pitcher.id !== constants.emptyGuid && pitcher.id === batter.id) {
    errors.push({
      dataKey: pitcherColumn.dataKey,
      errorMessage: 'Pitcher and Batter are the same',
    });
  }
  if (pitcher.id !== constants.emptyGuid && pitcher.id === catcher.id) {
    errors.push({
      dataKey: pitcherColumn.dataKey,
      errorMessage: 'Pitcher and Catcher are the same',
    });
  }
  if (batter.id !== constants.emptyGuid && batter.id === catcher.id) {
    errors.push({
      dataKey: batterColumn.dataKey,
      errorMessage: 'Batter and Catcher are the same',
    });
  }

  if (batter.id === constants.emptyGuid && !batter.isPlaceholder && !isPlayerCellEmpty(batter)) {
    errors.push({
      dataKey: batterColumn.dataKey,
      errorMessage: 'BatterId empty',
    });
  }

  if (pitcher.id === constants.emptyGuid && !pitcher.isPlaceholder && !isPlayerCellEmpty(pitcher)) {
    errors.push({
      dataKey: pitcherColumn.dataKey,
      errorMessage: 'PitcherId empty',
    });
  }

  if (catcher.id === constants.emptyGuid && !catcher.isPlaceholder && !isPlayerCellEmpty(catcher)) {
    errors.push({
      dataKey: catcherColumn.dataKey,
      errorMessage: 'CatcherId empty',
    });
  }
  return errors;
};
